<div class="main-page-wrapper p0 overflow-hidden">
    <div class="error-page d-lg-flex justify-content-center">
      
      <div class="text-center">
        <!-- <h3>Payment Detail</h3> -->
        <div class="pay_detail">
          <ul>
            <li>Amount : ₹<span>{{payment_detail?.net_amount_debit}}</span></li>
            <li>Payment Status : <span *ngIf="payment_detail?.payment_status === 'success'">Paid</span>
              <span *ngIf="payment_detail?.payment_status === 'pending'">Pending</span>
              <span *ngIf="payment_detail?.payment_status === 'failed'">Failed</span>
            </li>
            <li>Mode of Payment : <span>{{payment_detail?.mode_of_payment}}</span></li>

          </ul>
        <a (click)="Download()" target="_blank" class="theme-btn-one">Download Receipt</a>

        </div>
        <div class="icon-box mb-25"><img alt="" src="assets/images/icon/sucess.png"></div>
        <h1 class="font-slab mb-25">Payment Successful!</h1>

        <div class="d-lg-flex align-items-center justify-content-center">
          <button [routerLink]="['/']" class="theme-btn-three btn-md"> Back to homepage</button>
        </div>
      </div> <!-- /.text-wrapper -->
    </div>
  </div>
  